export enum FieldWrapperType {
  CHECKLIST = "checklist",
  APPLICATION = "application",
}

export enum CompanySectionAutomaticFillStatus {
  PROCESSING = "Processing",
  PROCESSED = "Processed",
  FINISHED = "Finished",
  FAILED = "Failed",
  OUTDATED = "Outdated",
}
